// Blog helpers — pure functions shared across blog components.

/**
 * Removes any <img> tags from an HTML description string so we can render
 * the text content without embedded images.
 */
export const stripImageFromDescription = (description) => {
  if (!description) return "";
  return description.replace(/<img[^>]*>/g, "");
};

/**
 * Formats a date string into a human-readable "June 28, 2025" format.
 */
export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
